(() => {
  const NN = window.NestNookUI = window.NestNookUI || {};

  NN.getConfig = () => {
    const el = document.getElementById('NestNookCardConfig');
    if (!el) return { titleLines: '2', colorMap: '' };
    try { return JSON.parse(el.textContent) || {}; } catch (_) { return { titleLines: '2', colorMap: '' }; }
  };

  NN.parseColorMap = (text) => {
    const map = {};
    String(text || '').split(/\r?\n/).forEach(line => {
      line = line.trim();
      if (!line) return;
      const hex = line.match(/#[0-9a-fA-F]{3,8}\b/);
      if (!hex) return;
      let name = line.slice(0, hex.index).replace(/[\s:=,|\-]+$/g, '').trim();
      if (name) map[name.toLowerCase()] = hex[0];
    });
    return map;
  };

  NN.applyCardSettings = (scope = document) => {
    const config = NN.getConfig();
    const lines = ['1','2','3','unlimited'].includes(String(config.titleLines)) ? String(config.titleLines) : '2';
    document.documentElement.dataset.nnCardTitleLines = lines;
    if (lines !== 'unlimited') document.documentElement.style.setProperty('--nn-card-title-lines', lines);
    const colors = NN.parseColorMap(config.colorMap);
    scope.querySelectorAll('[data-nn-swatch-name]').forEach(swatch => {
      if (swatch.dataset.nnSwatchImage === 'true') return;
      const name = String(swatch.dataset.nnSwatchName || '').trim().toLowerCase();
      if (colors[name]) swatch.style.backgroundColor = colors[name];
    });
  };

  NN.initReveal = (scope = document) => {
    const els = [...scope.querySelectorAll('.nn-reveal:not([data-nn-reveal-ready])')];
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      els.forEach(el => { el.dataset.nnRevealReady = '1'; el.classList.add('is-visible'); });
      return;
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: .08 });
    els.forEach(el => { el.dataset.nnRevealReady = '1'; io.observe(el); });
  };

  NN.initSlider = (root) => {
    if (!root || root.dataset.nnSliderReady === '1') return;
    const track = root.querySelector('[data-nn-track]');
    const slides = [...root.querySelectorAll('[data-nn-slide]')];
    if (!track || !slides.length) return;
    root.dataset.nnSliderReady = '1';
    const prev = root.querySelector('[data-nn-prev]');
    const next = root.querySelector('[data-nn-next]');
    const current = root.querySelector('[data-nn-current]');
    const total = root.querySelector('[data-nn-total]');
    const bar = root.querySelector('[data-nn-scrollbar]');
    const thumb = root.querySelector('[data-nn-thumb]');
    const allowDrag = root.dataset.nnDrag !== 'false';
    const snapToSlide = root.dataset.nnSnap === 'slide';
    let active = 0, suppressClick = false, pointerDown = false, dragStarted = false, startX = 0, startScroll = 0, scrollIdleTimer = 0, scrollFrame = 0;
    const getPageSize = () => { const desktop = Math.max(1, Number(root.dataset.nnPageSize || 1)); const mobile = Math.max(1, Number(root.dataset.nnPageSizeMobile || desktop)); return window.matchMedia('(max-width: 749px)').matches ? mobile : desktop; };
    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const maxStartIndex = () => Math.max(0, slides.length - getPageSize());
    const nearestIndex = () => { const left = track.scrollLeft; let best = 0, dist = Infinity; slides.forEach((slide, i) => { const d = Math.abs(slide.offsetLeft - left); if (d < dist) { dist = d; best = i; } }); return Math.min(best, maxStartIndex()); };
    const scrollToIndex = (i, smooth = true) => { i = Math.max(0, Math.min(maxStartIndex(), i)); const target = slides[i]; if (!target) return; track.scrollTo({ left: target.offsetLeft, behavior: smooth ? 'smooth' : 'auto' }); };
    const update = () => {
      active = nearestIndex();
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
      if (current) current.textContent = String(active + 1);
      if (total) total.textContent = String(slides.length);
      const max = maxScroll();
      root.classList.toggle('can-left', track.scrollLeft > 3); root.classList.toggle('can-right', track.scrollLeft < max - 3);
      if (prev) prev.disabled = track.scrollLeft <= 3; if (next) next.disabled = track.scrollLeft >= max - 3;
      if (thumb && bar) { const barWidth = bar.clientWidth; const visibleRatio = Math.min(1, track.clientWidth / Math.max(track.scrollWidth, 1)); const thumbWidth = Math.max(56, barWidth * visibleRatio); const travel = Math.max(0, barWidth - thumbWidth); const progress = max ? Math.min(1, Math.max(0, track.scrollLeft / max)) : 0; thumb.style.width = `${thumbWidth}px`; thumb.style.transform = `translate3d(${travel * progress}px,0,0)`; }
    };
    prev?.addEventListener('click', e => { e.preventDefault(); scrollToIndex(active - getPageSize()); });
    next?.addEventListener('click', e => { e.preventDefault(); scrollToIndex(active + getPageSize()); });
    track.addEventListener('scroll', () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(() => { update(); scrollFrame = 0; }); root.classList.add('is-scrolling'); clearTimeout(scrollIdleTimer); scrollIdleTimer = setTimeout(() => { root.classList.remove('is-scrolling'); update(); }, 120); }, { passive: true });
    if (allowDrag) {
      track.addEventListener('pointerdown', e => { if (e.pointerType === 'touch') return; if (e.button !== undefined && e.button !== 0) return; const interactive = e.target.closest('button,input,select,textarea,[data-nn-no-drag]'); if (interactive && !interactive.closest('[data-nn-drag-surface]')) return; pointerDown = true; dragStarted = false; startX = e.clientX; startScroll = track.scrollLeft; });
      track.addEventListener('pointermove', e => { if (!pointerDown) return; const dx = e.clientX - startX; if (!dragStarted && Math.abs(dx) > 7) { dragStarted = true; suppressClick = true; track.classList.add('is-dragging'); track.setPointerCapture?.(e.pointerId); } if (dragStarted) track.scrollLeft = startScroll - dx; });
      const endPointer = e => { if (!pointerDown) return; pointerDown = false; if (dragStarted && e?.pointerId !== undefined && track.hasPointerCapture?.(e.pointerId)) track.releasePointerCapture(e.pointerId); track.classList.remove('is-dragging'); if (dragStarted) { requestAnimationFrame(() => scrollToIndex(nearestIndex())); setTimeout(() => { suppressClick = false; }, 80); } dragStarted = false; };
      track.addEventListener('pointerup', endPointer); track.addEventListener('pointercancel', endPointer);
      track.addEventListener('click', e => { if (!suppressClick) return; e.preventDefault(); e.stopPropagation(); }, true);
    }
    if (bar && thumb) {
      let thumbDown = false, thumbStartX = 0, thumbStartScroll = 0;
      thumb.addEventListener('pointerdown', e => { e.preventDefault(); e.stopPropagation(); thumbDown = true; thumbStartX = e.clientX; thumbStartScroll = track.scrollLeft; thumb.classList.add('is-dragging'); thumb.setPointerCapture?.(e.pointerId); });
      let thumbFrame = 0, thumbTarget = 0;
      thumb.addEventListener('pointermove', e => { if (!thumbDown) return; const max = maxScroll(); const travel = Math.max(1, bar.clientWidth - thumb.offsetWidth); thumbTarget = thumbStartScroll + ((e.clientX - thumbStartX) / travel) * max; if (thumbFrame) return; thumbFrame = requestAnimationFrame(() => { track.scrollLeft = thumbTarget; thumbFrame = 0; }); });
      const thumbEnd = e => { if (!thumbDown) return; thumbDown = false; thumb.classList.remove('is-dragging'); thumb.releasePointerCapture?.(e?.pointerId); if (snapToSlide) requestAnimationFrame(() => scrollToIndex(nearestIndex())); };
      thumb.addEventListener('pointerup', thumbEnd); thumb.addEventListener('pointercancel', thumbEnd);
      bar.addEventListener('pointerdown', e => { if (e.target === thumb) return; const rect = bar.getBoundingClientRect(); const ratio = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width)); const targetLeft = maxScroll() * ratio; if (snapToSlide) { let best = 0, dist = Infinity; slides.forEach((slide, i) => { const d = Math.abs(slide.offsetLeft - targetLeft); if (d < dist) { dist = d; best = i; } }); scrollToIndex(best); } else { track.scrollTo({ left: targetLeft, behavior: 'smooth' }); } });
    }
    let autoplayTimer; const autoplay = Number(root.dataset.nnAutoplay || 0);
    const restartAutoplay = () => { clearInterval(autoplayTimer); if (autoplay > 0 && slides.length > getPageSize() && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) autoplayTimer = setInterval(() => scrollToIndex(active >= maxStartIndex() ? 0 : active + getPageSize()), autoplay * 1000); };
    root.addEventListener('pointerenter', () => clearInterval(autoplayTimer)); root.addEventListener('pointerleave', restartAutoplay);
    window.addEventListener('resize', () => { scrollToIndex(Math.min(active, maxStartIndex()), false); update(); }, { passive: true });
    update(); restartAutoplay();
  };

  NN.initSliders = (scope = document) => scope.querySelectorAll('[data-nn-slider]').forEach(NN.initSlider);

  NN.initUgcLightboxes = (scope = document) => {
    const roots = [];
    if (scope?.matches?.('.nn-ugc')) roots.push(scope);
    scope?.querySelectorAll?.('.nn-ugc').forEach(root => roots.push(root));

    roots.forEach(root => {
      if (!root.id || root.dataset.nnUgcControllerReady === '1') return;

      const track = root.querySelector('[data-nn-track]');
      const openers = [...root.querySelectorAll('[data-ugc-open]')];
      const modal = document.getElementById(`${root.id}-lightbox`) || root.querySelector('[data-ugc-lightbox]');
      if (!track || !modal || !openers.length) return;

      root.dataset.nnUgcControllerReady = '1';
      if (modal.parentElement !== document.body) document.body.appendChild(modal);

      const slides = [...modal.querySelectorAll('[data-ugc-slide]')];
      if (!slides.length) return;

      slides.forEach(slide => {
        const info = slide.querySelector('.nn-ugc-lightbox__info');
        if (!info) return;
        const hasInfo = !!info.querySelector('.nn-ugc-lightbox__platform,.nn-ugc-lightbox__post-link,.nn-ugc-lightbox__products');
        if (!hasInfo) {
          info.hidden = true;
          slide.style.gridTemplateColumns = 'minmax(0,1fr)';
        }
      });

      let index = 0;
      let lastFocus = null;
      let previousHtmlOverflow = '';
      let previousBodyOverflow = '';
      let pointerDown = false;
      let pointerMoved = false;
      let startX = 0;
      let startY = 0;
      let suppressClickUntil = 0;

      const show = value => {
        index = (Number(value) + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      };

      const open = value => {
        lastFocus = document.activeElement;
        show(value);
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        previousHtmlOverflow = document.documentElement.style.overflow;
        previousBodyOverflow = document.body.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        modal.querySelector('[data-ugc-close]')?.focus({ preventScroll: true });
      };

      const close = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = previousHtmlOverflow;
        document.body.style.overflow = previousBodyOverflow;
        lastFocus?.focus?.({ preventScroll: true });
      };

      track.addEventListener('pointerdown', event => {
        if (!event.target.closest('[data-ugc-open]')) return;
        pointerDown = true;
        pointerMoved = false;
        startX = event.clientX;
        startY = event.clientY;
      }, true);

      track.addEventListener('pointermove', event => {
        if (!pointerDown) return;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        if (Math.hypot(dx, dy) > 8) pointerMoved = true;
      }, true);

      const endPointer = () => {
        if (!pointerDown) return;
        if (pointerMoved) suppressClickUntil = performance.now() + 280;
        pointerDown = false;
      };
      track.addEventListener('pointerup', endPointer, true);
      track.addEventListener('pointercancel', () => {
        if (pointerDown) suppressClickUntil = performance.now() + 280;
        pointerDown = false;
        pointerMoved = false;
      }, true);

      track.addEventListener('click', event => {
        const opener = event.target.closest('[data-ugc-open]');
        if (!opener) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (performance.now() < suppressClickUntil || pointerMoved) {
          pointerMoved = false;
          return;
        }
        pointerMoved = false;
        open(Number(opener.dataset.ugcOpen || 0));
      }, true);

      modal.addEventListener('click', event => {
        const closeButton = event.target.closest('[data-ugc-close]');
        const prevButton = event.target.closest('[data-ugc-prev]');
        const nextButton = event.target.closest('[data-ugc-next]');
        if (!closeButton && !prevButton && !nextButton) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (closeButton) close();
        else if (prevButton) show(index - 1);
        else if (nextButton) show(index + 1);
      }, true);

      modal.addEventListener('keydown', event => {
        if (!modal.classList.contains('is-open')) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopImmediatePropagation();
          close();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          event.stopImmediatePropagation();
          show(index - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          event.stopImmediatePropagation();
          show(index + 1);
        }
      }, true);
    });
  };

  NN.initSwatches = (scope = document) => {
    scope.querySelectorAll('.nn-product-card:not([data-nn-card-ready])').forEach(card => {
      card.dataset.nnCardReady = '1';
      const image = card.querySelector('[data-nn-card-image]');
      const variantInput = card.querySelector('[data-nn-variant-input]');
      const price = card.querySelector('[data-nn-price]');
      const compare = card.querySelector('[data-nn-compare]');
      const badge = card.querySelector('[data-nn-card-badge]');

      const updateBadge = swatch => {
        if (!badge || badge.dataset.badgeType === 'soldout') return;
        const pct = Number(swatch?.dataset.salePercent || 0);
        const amount = String(swatch?.dataset.saleAmount || '');
        const saleEnabled = badge.dataset.saleEnabled === 'true';
        if (saleEnabled && pct > 0) {
          const detail = badge.dataset.saleMode === 'amount' && amount ? `Save ${amount}` : `${pct}% Off`;
          const label = String(badge.dataset.saleLabel || '').trim();
          badge.textContent = label ? `${label} · ${detail}` : detail;
          badge.style.backgroundColor = badge.dataset.saleBg || '';
          badge.style.color = badge.dataset.saleColor || '';
          badge.style.borderColor = 'transparent';
          badge.dataset.badgeType = 'sale';
          badge.hidden = false;
          return;
        }
        if (badge.dataset.newEligible === 'true') {
          badge.textContent = badge.dataset.newText || 'New';
          badge.style.backgroundColor = badge.dataset.newBg || '';
          badge.style.color = badge.dataset.newColor || '';
          badge.style.borderColor = 'transparent';
          badge.dataset.badgeType = 'new';
          badge.hidden = false;
          return;
        }
        badge.dataset.badgeType = '';
        badge.hidden = true;
      };

      const swatches = [...card.querySelectorAll('[data-nn-swatch]')];
      const imageCache = new Map();
      let imageSwapToken = 0;

      const warmImage = url => {
        if (!url) return Promise.resolve(null);
        if (imageCache.has(url)) return imageCache.get(url);
        const preload = new Image();
        preload.decoding = 'async';
        const ready = new Promise(resolve => {
          const done = () => resolve(preload);
          preload.addEventListener('load', done, { once: true });
          preload.addEventListener('error', done, { once: true });
          preload.src = url;
          if (preload.complete) resolve(preload);
        }).then(img => {
          if (img && typeof img.decode === 'function') return img.decode().catch(() => {}).then(() => img);
          return img;
        });
        imageCache.set(url, ready);
        return ready;
      };

      const swapImage = url => {
        if (!image || !url) return;
        const token = ++imageSwapToken;
        warmImage(url).then(() => {
          if (token !== imageSwapToken) return;
          image.removeAttribute('srcset');
          image.src = url;
        });
      };

      const warmCardVariants = () => {
        swatches.forEach(swatch => warmImage(swatch.dataset.image));
      };
      card.addEventListener('pointerenter', warmCardVariants, { once: true, passive: true });
      card.addEventListener('focusin', warmCardVariants, { once: true });

      swatches.forEach(swatch => {
        const warmCurrent = () => warmImage(swatch.dataset.image);
        swatch.addEventListener('pointerenter', warmCurrent, { passive: true });
        swatch.addEventListener('touchstart', warmCurrent, { passive: true });
        swatch.addEventListener('focus', warmCurrent);
        swatch.addEventListener('click', e => {
          e.preventDefault(); e.stopPropagation();
          swatches.forEach(x => x.classList.remove('is-active'));
          swatch.classList.add('is-active');
          if (variantInput && swatch.dataset.variantId) variantInput.value = swatch.dataset.variantId;
          if (swatch.dataset.image) swapImage(swatch.dataset.image);
          if (price && swatch.dataset.price) { price.textContent = swatch.dataset.price; price.classList.toggle('is-sale', Number(swatch.dataset.salePercent || 0) > 0); }
          if (compare) { compare.textContent = swatch.dataset.compare || ''; compare.hidden = !swatch.dataset.compare; }
          updateBadge(swatch);
        });
      });
    });
  };

  NN.init = (scope = document) => { NN.applyCardSettings(scope); NN.initReveal(scope); NN.initSliders(scope); NN.initUgcLightboxes(scope); NN.initSwatches(scope); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => NN.init()); else NN.init();
  document.addEventListener('shopify:section:load', e => NN.init(e.target));
})();
